/**
 * Marca e formatos da plataforma (Administração › Geral): carregados antes de a tela aparecer (main.tsx) e lidos pelas
 * funções de formatação, pelo logo, pelo campo de data e pela impressão. Mudou na Administração: vale ao recarregar.
 */
import type { DateOrder, TimeFormat } from '@pmis/shared';

export interface Branding {
  formats: { date: DateOrder; time: TimeFormat };
  print: { footerText: string; showPrintedBy: boolean; showCover?: boolean; headerText?: string; header: string | null; footer: string | null; cover?: string | null };
  logo: { light: string | null; dark: string | null; icon: string | null };
}

const DEFAULT: Branding = {
  formats: { date: 'dmy', time: '24h' },
  print: { footerText: 'AD Digital', showPrintedBy: true, header: null, footer: null },
  logo: { light: null, dark: null, icon: null },
};

let current: Branding = DEFAULT;

export const branding = () => current;

/** Busca a marca e os formatos; sem resposta (servidor fora), fica o padrão da AD Digital. */
export async function loadBranding() {
  try {
    const r = await fetch('/api/v1/branding', { headers: { Accept: 'application/json' } });
    if (r.ok) current = { ...DEFAULT, ...(await r.json() as Branding) };
  } catch { /* padrão */ }
  if (current.logo.icon) document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', current.logo.icon);
  return current;
}
